import styles from './VoteHistoryModal.module.css';

const VOTE_LABEL = { favor: 'A favor', contra: 'En contra', abstencion: 'Abstención' };
const VOTE_ICON  = { favor: 'fa-thumbs-up', contra: 'fa-thumbs-down', abstencion: 'fa-minus' };
const VOTE_COLOR = { favor: '#12b76a', contra: '#f04438', abstencion: '#8a92a6' };

export default function VoteHistoryModal({ votedQuestions, myVotes, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal ${styles.historial}`} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3><i className={`fas fa-history ${styles.icono}`} />Historial de votos</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>
        <div className={`modal-body ${styles.cuerpo}`}>
          {votedQuestions.length === 0 ? (
            <div className={styles.vacio}>
              <i className={`fas fa-inbox ${styles.vacioIcono}`} />
              Aún no has votado en ninguna pregunta
            </div>
          ) : votedQuestions.map((q, i) => {
            const answer = myVotes[q.id];
            const color  = VOTE_COLOR[answer] || 'var(--accent)';
            return (
              <div key={q.id} className={`${styles.voto} ${i < votedQuestions.length - 1 ? styles.votoConLinea : ''}`}
                style={{ '--tono': color, '--fondo': color + '22' }}>
                <div className={styles.votoIcono}>
                  <i className={`fas ${VOTE_ICON[answer] || 'fa-check'} ${styles.votoGlifo}`} />
                </div>
                <div className={styles.votoTexto}>
                  <div className={styles.votoPregunta}>{q.question_text}</div>
                  <span className={styles.votoChip}>
                    <i className={`fas ${VOTE_ICON[answer] || 'fa-check'} ${styles.icono5}`} />
                    {VOTE_LABEL[answer] || answer}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="modal-footer">
          <span className={styles.pie}>
            {votedQuestions.length} voto{votedQuestions.length !== 1 ? 's' : ''} registrado{votedQuestions.length !== 1 ? 's' : ''}
          </span>
          <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}
